<div class="flex w-full items-center gap-1 text-gray-500">
	<span class="text-3.25">دارایی فعلی</span>
	<ui-button
		variant="ghost"
		size="default"
		iconOnly
		data-testid="order-form-current-asset"
		label="استفاده از دارایی فعلی به عنوان تعداد"
		extraButtonClasses="text-3.25 font-medium text-gray-900! underline underline-offset-2"
		(click)="onCurrentAssetClick()">
		<ui-number format="1.0-0" [value]="summary().currentAsset" />
	</ui-button>
</div>

<div class="flex w-full flex-col gap-1">
	<!-- Never masked, deliberately: «عدم نمایش مانده» hides balances everywhere else,
		but a trader sizing an order has to see what they can spend. See the component. -->
	<div class="flex w-full items-center justify-between gap-1 text-3.25 font-bold text-gray-900">
		<span>قدرت خرید</span>
		<span class="flex items-center gap-1">
			<ui-number format="1.0-0" data-cy="order-form-buying-power" [value]="summary().buyingPower" />
			<span class="font-normal text-gray-500">ریال</span>
		</span>
	</div>

	@if (summary().breakEvenPrice !== null) {
		<ui-divider />

		<div class="flex w-full items-center justify-between gap-1 text-3.25 text-gray-500">
			<span>قیمت سربه‌سر</span>
			<span class="flex items-center gap-1 font-medium text-gray-900">
				<ui-number format="1.0-0" [value]="summary().breakEvenPrice!" />
				<span class="font-normal text-gray-500">ریال</span>
			</span>
		</div>
	}

	<ui-divider />

	<div class="flex w-full items-center justify-between gap-1 text-3.25 text-gray-500">
		<span>کارمزد معامله</span>
		<span class="flex items-center gap-1 font-medium text-gray-900">
			<ui-number format="1.0-0" [value]="summary().dealExpense" />
			<span class="font-normal text-gray-500">ریال</span>
		</span>
	</div>

	<ui-divider />

	<div class="flex w-full items-center justify-between gap-1 text-3.25 text-gray-500">
		<span>جمع کل</span>
		<span class="flex items-center gap-1 font-medium text-gray-900">
			<ui-number format="1.0-0" [value]="summary().totalExpense" />
			<span class="font-normal text-gray-500">ریال</span>
		</span>
	</div>
</div>
